import { createAction } from '@reduxjs/toolkit';
import type { Expense } from '@/lib/types';

export const loadExpenses = createAction('expenses/LOAD_EXPENSES');

export const loadExpensesSuccess = createAction(
  'expenses/LOAD_EXPENSES_SUCCESS',
  (expenses: Expense[]) => ({ payload: { expenses } })
);

export const loadExpensesError = createAction(
  'expenses/LOAD_EXPENSES_ERROR',
  (error: string) => ({ payload: { error } })
);

export const saveExpenseRequest = createAction(
  'expenses/SAVE_EXPENSE_REQUEST',
  (expense: { category?: string; description: string; amount: number; expenseDate?: string; paymentMethod?: string; paidAmount?: number }) => ({
    payload: { expense },
  })
);

export const updateExpenseRequest = createAction(
  'expenses/UPDATE_EXPENSE_REQUEST',
  (
    id: string,
    expense: { category?: string; description: string; amount: number; expenseDate?: string; paymentMethod?: string; paidAmount?: number }
  ) => ({
    payload: { id, expense },
  })
);

export const cancelExpenseRequest = createAction(
  'expenses/CANCEL_EXPENSE_REQUEST',
  (id: string) => ({ payload: { id } })
);
